// extracted by mini-css-extract-plugin
export default {"cuerpo":"Datos_cuerpo__AuHVb"};